<template>
    <div class="app-container">
      <BjDivider right-fixed
        >{{ $t('RoleManagement.common.menu') }}
        <template #right>
          <el-button @click="handleClose">{{ $t('backText') }}</el-button>
          <el-button type="primary" @click="onSave">{{ $t('okText') }}</el-button>
        </template>
      </BjDivider>

      <el-row>
        <BjInput
          v-model="filterText"
          :maxlength="MAX_LENGTH.DEFAULT"
          :placeholder="$t('RoleManagement.child.filter')"
          class="mb16"
          style="width: 400px"
        />
      </el-row>
      <el-tree
        ref="tree"
        :data="data"
        show-checkbox
        node-key="id"
        highlight-current
        :props="defaultProps"
        :filter-node-method="filterNode"
        :default-checked-keys="checkedList"
      >
        <span slot-scope="{ node, data }" class="custom-tree-node">
          <span
            ><el-tag
              class="el-tag-left"
              :type="SETTING_PERMISSION_TYPE_COLOR_LIST.bjGet(data.permissionType)"
              >{{ $t(SETTING_PERMISSION_TYPE_LIST.bjGet(data.permissionType)) }}</el-tag
            >
            {{ $t(`route.${node.label}`) }}
            </span
          >
        </span>
      </el-tree>
    </div>
  </template>

  <script>
  import viewMiXin from '@/utils/view-mixin.js';
  import { roleApi } from '@/api';
  import {
    SETTING_PERMISSION_TYPE_LIST,
    SETTING_PERMISSION_TYPE_COLOR_LIST,
  } from '@/utils/constants';
  export default {
    name: 'BusinessUserRoleAllotMenu',
    mixins: [viewMiXin],
    data() {
      return {
        SETTING_PERMISSION_TYPE_LIST,
        SETTING_PERMISSION_TYPE_COLOR_LIST,
        data: [],
        defaultProps: {
          children: 'children',
          label: 'code',
          // code: 'code'
        },
        filterText: '',
        // 选中菜单ids
        checkedList: [],
        childrenIds: [],
      };
    },
    watch: {
      filterText(val) {
        this.$refs.tree.filter(val);
      },
    },
    mounted() {
      this.getData(this.$route.query.roleId);
    },
    methods: {
      getData(roleId) {
        roleApi
          .getAllmenu({ roleId: roleId })
          .then(res => {
            this.data = res.menuTrees;
            const childrenIds = this.filterData(res.menuTrees);
            res.checkedList.forEach(id => {
              // 判断是否是最后一层的id
              if (childrenIds.indexOf(id) !== -1) {
                this.checkedList.push(id);
              }
            });
          });
      },
      /**
       * 筛选出数据的最后一层id
       */
      filterData(list) {
        list.forEach(item => {
          if (item.children === null) {
            this.childrenIds.push(item.id);
          } else {
            this.filterData(item.children);
          }
        });
        return this.childrenIds;
      },
      /**
       * roleId: 角色id
       * menuIds: 菜单ids
       */
      onSave() {
        const roleId = this.$route.query.roleId;
        const menuIds = [
          ...this.$refs.tree.getCheckedKeys(),
          ...this.$refs.tree.getHalfCheckedKeys(),
        ];
        if (menuIds.length == 0) return this.$message.warning(this.$t('chooseText'));
        roleApi
          .saveRoleMenu({ roleId, menuIds })
          .then(res => {
            if (!res.failed) {
              this.msgSuccess(this.$t('toast.operationSuccessText'));
              setTimeout(() => {
                this.handleClose();
              }, 500);
            }
          });
      },
      filterNode(value, data) {
        if (!value) return true;
        return data.title.indexOf(value) !== -1;
      },
      /* 关闭弹窗 */
      handleClose() {
        this.cancel();
      },
    },
  };
  </script>

  <style lang="scss" scoped>
  .el-tag-left {
    margin-right: 8px;
  }
  .foot {
    position: absolute;
    bottom: 15px;
    left: 0;
    width: 100%;
    text-align: center;
  }
  </style>
